import * as categoriesActions from './actions';
import categoriesReducer from './reducer';
import * as categoriesTypes from './types';
import * as categoriesUtils from './utils';

export {categoriesActions, categoriesTypes, categoriesUtils};

export default categoriesReducer;
